if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 750px)");
        if (!this.elements.thumbnails) return;

        // Listener para cambios en el slider (swipe o botones next/prev)
        this.elements.viewer.addEventListener(
          "slideChanged",
          this.onSlideChanged.bind(this)
        );

        // Listener para clics en thumbnails
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener("click", (event) => {
                event.preventDefault();
                const targetId = mediaToSwitch.dataset.target;
                this.setActiveMedia(targetId, false);
              });
          });

        // Ajustar comportamiento en escritorio si hay miniaturas
        if (
          this.dataset &&
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        ) {
          if (this.removeListSemantic) {
            this.removeListSemantic();
          }
        }
      }

      onSlideChanged(event) {
        const currentSlideId = event.detail.currentElement.dataset.mediaId;

        // Buscar el thumbnail correspondiente
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentSlideId}"]`
        );

        // Actualizar la clase activa en el thumbnail
        this.setActiveThumbnail(thumbnail);
        console.log(
          "Cambio de slide detectado (swipe o navegación):",
          currentSlideId,
          thumbnail
        );
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );

        if (!activeMedia) {
          console.error(`No se encontró el slide con mediaId: ${mediaId}`);
          return;
        }

        // Limpiar clases activas de todos los slides
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });

        // Agregar la clase activa al slide seleccionado
        activeMedia.classList.add("is-active");

        // Forzar actualización del viewer para reflejar el cambio
        if (this.elements.viewer.slider) {
          this.elements.viewer.slider.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "smooth",
          });
        }

        // Prepend opcional (si es necesario para diseño)
        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
        }

        // Actualizar thumbnail activo
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);

        // Emitir evento de cambio de slide
        const slideChangedEvent = new CustomEvent("slideChanged", {
          detail: { currentElement: activeMedia },
        });
        this.elements.viewer.dispatchEvent(slideChangedEvent);

        console.log(`Slide cambiado por clic en thumbnail: ${mediaId}`);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        // Limpiar la clase 'is-active' de todos los thumbnails
        this.elements.thumbnails
          .querySelectorAll(".thumbnail-number")
          .forEach((element) => {
            element.classList.remove("is-active");
          });

        // Agregar la clase 'is-active' al thumbnail actual
        const thumbnailButton = thumbnail.querySelector(".thumbnail-number");
        if (thumbnailButton) {
          thumbnailButton.classList.add("is-active");
        }
      }
    }
  );
}
